module.exports = __webpack_public_path__ + "img/escudo-nl2.d031ec06.svg";